var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"ml-3 headline font-weight-bold",attrs:{"cols":"12"}},[_vm._t("before"),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("after")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }